import styled from "styled-components";

const QuoteBoxWrapper = styled.a`
  background-color: #fafafa;
  display: flex;
  height: 60px;
  border-top-left-radius: 60px;
  border-bottom-left-radius: 60px;
  text-decoration: none;
  color: black;
  > img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: contain;
    object-position: center;
  }
  > span:last-child {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 8px 0px;
    padding-left: 16px;
    > span:first-child {
      font-weight: bold;
    }
  }
`;
const DeletedQuote = styled.span`
  display: block;
  padding: 8px 16px;
  background-color: #fafafa;
  border-radius: 10px;
  text-align: center;
`;

const QuoteBox = ({ href, msg }) => {
  const descr = msg.descr.replace(/(<([^>]+)>)/gi, "");
  return msg.deleted === "N" ? (
    <QuoteBoxWrapper href={href}>
      <img src={`${process.env.REACT_APP_BECCO_API_URL}/api/employee/image/${msg.au}`} alt={`profile of ${msg.au}`} />
      <span>
        <span>{msg.auName}</span>
        <span>{descr.length > 50 ? descr.slice(0, 50) + "..." : descr}</span>
      </span>
    </QuoteBoxWrapper>
  ) : (
    <DeletedQuote>삭제된 메시지입니다</DeletedQuote>
  );
};

export default QuoteBox;
